import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import CircularService from "./CircularService";


export const getCirculars = createAsyncThunk("Circular/get-Circulars", async (token,thunkAPI) => {
  try {
    return await CircularService.getCirculars(token);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createCircular = createAsyncThunk(
  "Circular/create-Circulars",
  async (AssociationData, thunkAPI) => {
    try {
      return await CircularService.createCircular(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getCircular = createAsyncThunk(
  "Circular/get-Circular",
  async (id, thunkAPI) => {
    try {
      return await CircularService.getCircular(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateCircular = createAsyncThunk(
  "Circular/update-Circular",
  async (id, thunkAPI) => {
    try {
      return await CircularService.updateCircular(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteCircular = createAsyncThunk(
  "Circular/delete-Circular",
  async (id, thunkAPI) => {
    try {
      return await CircularService.deleteCircular(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Circulars: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Circular",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCirculars.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCirculars.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Circulars = action.payload.data;
      })
      .addCase(getCirculars.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createCircular.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCircular.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdCircular = action.payload;
      })
      .addCase(createCircular.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getCircular.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCircular.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.circularcontent= action.payload.data.content;
        state.circulartitle= action.payload.data.title;
      })
      .addCase(getCircular.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateCircular.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCircular.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedCircular = action.payload;
      })
      .addCase(updateCircular.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteCircular.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCircular.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedCircular = action.payload;
      })
      .addCase(deleteCircular.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
